import React from 'react';
import './combo-products.scss';
import {
  getBackgroundImageUrl,
  getDiscountText,
} from 'hb-redux-store/util/miscellaneousServices';
import history from 'hb-redux-store/history';
import { Link } from 'react-router-dom';
import Button from '../../common/Button/Button';
import ButtonCounter from '../../common/Button/ButtonCounter';
import {
  postAddItem,
  postRemoveItem,
} from 'hb-redux-store/feature/cart/cart.action';
import { connect } from 'react-redux';
import { setAppNotification } from 'hb-redux-store/initial.action';
import { notifyUser } from 'hb-redux-store/feature/products/product.action';
import { createComboProductUrl } from '../../../CPMapping';
import { showNonServiceableModal } from 'hb-redux-store/feature/modal/modal.action';
import Icon from '../Icon/Icon';
import HighLightTags from '../HighlightTags/HighlightTags';

import addIcon from 'assets/icons/icon-add.svg';

const GET_COMBO_TEXT = 'Get combo @';
const ITEM_TEXT = 'items in the Combo';
const REMOVE_COMBO_TEXT = 'REMOVE COMBO FROM CART';

class ComboCard extends React.Component {
  state = {
    product: this.props.product,
    discountText: getDiscountText({
      product: this.props.product,
      isCombo: true,
    }),
  };

  toLink = createComboProductUrl(this.props.product.comboProductId);

  successOpCb = msg => ({ skuCount }) => {
    const newProduct = { ...this.state.product, inCartQuantity: skuCount };
    this.props.setAppNotification(msg);
    this.setState({ product: newProduct, opInProgress: false });
  };

  failOpCb = msg => ({ errorMessage = msg }) => {
    if (errorMessage !== 'Please select a location.')
      this.props.setAppNotification(errorMessage);
    this.setState({ opInProgress: false });
  };

  addToCart = () => {
    this.setState({ opInProgress: true }, () => {
      const { product } = this.state;
      this.props.postAddItem({
        comboProductId: product.comboProductId,
        productName: product.comboName,
        price: product?.salePrice ?? product?.retailPrice,
        quantity: 1,
        source: this.props.source,
        isCart: this.props.source === 'cart',
        successOpCb: this.successOpCb('Item added to cart'),
        failOpCb: this.failOpCb('Error adding item to cart'),
      });
    });
  };

  removeFromCart = () => {
    this.setState({ opInProgress: true }, () => {
      const { product } = this.state;
      this.props.postRemoveItem({
        comboProductId: product.comboProductId,
        productName: product.comboName,
        price: product?.salePrice ?? product?.retailPrice,
        quantity: 1,
        source: this.props.source,
        isCart: this.props.source === 'cart',
        successOpCb: this.successOpCb('Item removed from cart'),
        failOpCb: this.failOpCb('Error removing item to cart'),
      });
    });
  };
  notify = () => {
    const { setAppNotification, showNonServiceableModal } = this.props;
    if (!this.props.loggedInState) {
      return setAppNotification('Please login to get notified.');
    }
    this.props.notifyUser({
      sku: 'COMBO-' + this.state.product.comboProductId,
      errorCb: e => {
        const message =
          e.data?.description ||
          e.data?.error?.errorMessage ||
          'Unable to process your request';
        if (e.status === 401) {
          setAppNotification('Please login to get notified.');
        }
        if (e.status === 500 && message === 'Please select a location.') {
          showNonServiceableModal({ visible: true, source: 'notifyMe' });
        }
      },
    });
  };

  render() {
    const { product, discountText } = this.state;
    const onSale = product?.salePrice < product?.retailPrice;
    // const { sku } = this.state;
    // comboDescription: "combo-002"
    // comboDiscountPercentage: 20
    // comboName: "combo-002"
    // comboPrimaryImage: "https://ik.imagekit.io/iwcam3r8ka/combo/202012/5712e9a2-75cd-4137-974f-04e94256222b.jpeg"
    // comboProductId: 2
    // comboProductItems: (2) [{…}, {…}]
    // comboSecondaryImages: (2) [{…}, {…}]
    // inCartQuantity: 0
    // isInventoryAvailable: true
    // isPresale: false
    // maxQuantityCart: 5
    // products: (2) [{…}, {…}]
    // retailPrice: 290
    // salePrice: 232
    return (
      <div className="combo-card">
        <div className="combo-card--main">
          <span className="combo-card--header-text">
            {product?.productSet?.length} {ITEM_TEXT}
          </span>
          <div
            className="combo-card--image-container"
            onClick={() => history.push(this.toLink)}
          >
            {product?.productSet.map((item, index) => {
              const primaryImage = item.images.find(i => {
                if (i.isPrimary) return i;
                return {};
              });
              return (
                <div className="combo-card--wrapper">
                  <img
                    src={primaryImage?.url}
                    className={`combo-card--img ${
                      !product.isInventoryAvailable
                        ? 'combo-card--img-opacity'
                        : ''
                    }`}
                  />
                  <div className="combo-card--product-name">
                    {item?.productName}
                  </div>
                  {index != product?.productSet?.length - 1 && (
                    <div className="combo-card--add-image-container">
                      <img
                        src={addIcon}
                        className={`combo-card--add-image ${
                          !product.isInventoryAvailable
                            ? 'combo-card--img-opacity'
                            : ''
                        }`}
                      />
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
        {!product.isInventoryAvailable && (
          <div className="combo-card--out-of-stock-wrapper">
            <span className="combo-card--out-of-stock">OUT OF STOCK</span>
          </div>
        )}

        {!product.isInventoryAvailable && (
          <div className="combo-card--notify-wrapper">
            <Button className="button action-link" onClick={this.notify}>
              Notify Me
            </Button>
          </div>
        )}

        <div className="combo-card--button-alignment">
          {product?.isInventoryAvailable && product?.inCartQuantity === 0 && (
            <Button
              className="button button-ghost full-width combo-card--bottom-button"
              onClick={this.addToCart}
              disabled={this.state.opInProgress}
            >
              {GET_COMBO_TEXT} &#8377;
              {product?.salePrice ? product?.salePrice : product?.retailPrice}
            </Button>
          )}
          {product?.isInventoryAvailable && product?.inCartQuantity > 0 && (
            <div className="combo-card--button-right">
              <ButtonCounter
                className="button-counter-ghost"
                onIncrement={this.addToCart}
                onDecrement={this.removeFromCart}
                disabled={this.state.opInProgress}
                counter={product.inCartQuantity}
              />
            </div>
          )}
        </div>
      </div>
    );
  }
}
const mapStateToProps = ({ initialReducer }) => ({
  loggedInState: initialReducer.launchInfo.loggedIn,
});
const mapDispatchToProps = {
  postAddItem,
  postRemoveItem,
  setAppNotification,
  notifyUser,
  showNonServiceableModal,
};
export default connect(mapStateToProps, mapDispatchToProps)(ComboCard);
